// IANA zones offered in the call picker, grouped the way a patient scans for
// their own. Labels are shown verbatim in the list; the header shortens them.

export const TIME_ZONE_GROUPS = [
  {
    group: "US/Canada",
    zones: [
      ["America/Los_Angeles", "Pacific Time - US & Canada"],
      ["America/Denver", "Mountain Time - US & Canada"],
      ["America/Chicago", "Central Time - US & Canada"],
      ["America/New_York", "Eastern Time - US & Canada"],
      ["America/Toronto", "Eastern Time - Canada (Toronto)"],
      ["America/Anchorage", "Alaska Time"],
    ],
  },
  {
    group: "America",
    zones: [
      ["America/Adak", "America/USA/Adak"],
      ["America/Argentina/Buenos_Aires", "America/Argentina/Buenos Aires"],
      ["America/Belize", "America/Belize/Belize City"],
      ["America/Bogota", "America/Colombia/Bogota"],
      ["America/Guayaquil", "America/Ecuador/Guayaquil"],
      ["America/Panama", "America/Panama/Panama City"],
      ["America/Lima", "America/Peru/Lima"],
      ["America/Jamaica", "America/Jamaica/Kingston"],
      ["America/Boise", "America/USA/Boise"],
      ["America/Caracas", "America/Venezuela/Caracas"],
      ["America/Chihuahua", "America/Mexico/Chihuahua"],
      ["America/Guatemala", "America/Guatemala/Guatemala City"],
      ["America/El_Salvador", "America/El Salvador/San Salvador"],
      ["America/Tegucigalpa", "America/Honduras/Tegucigalpa"],
      ["America/Managua", "America/Nicaragua/Managua"],
      ["America/Costa_Rica", "America/Costa Rica/San Jose"],
      ["America/Detroit", "America/USA/Detroit"],
      ["America/Nuuk", "America/Greenland/Godthab"],
      ["America/Juneau", "America/Alaska/Juneau"],
      ["America/Nome", "America/Alaska/Nome"],
      ["America/Sitka", "America/Alaska/Sitka"],
      ["America/Yakutat", "America/Alaska/Yakutat"],
      ["America/Mexico_City", "America/Mexico/Mexico City"],
      ["America/Tijuana", "America/Mexico/Tijuana"],
      ["America/Montevideo", "America/Uruguay/Montevideo"],
      ["America/Phoenix", "America/USA/Phoenix"],
      ["America/Dawson", "America/Canada/Dawson"],
      ["America/Regina", "America/Canada/Regina"],
      ["America/St_Johns", "America/Canada/St Johns"],
      ["America/Santiago", "America/Chile/Santiago"],
      ["America/Sao_Paulo", "America/Brazil/Sao Paulo"],
      ["America/Cancun", "America/Mexico/Cancun"],
    ],
  },
  {
    group: "Africa",
    zones: [
      ["Africa/Algiers", "Africa/Algeria/Algiers"],
      ["Africa/Cairo", "Africa/Egypt/Cairo"],
      ["Africa/Casablanca", "Africa/Morocco/Casablanca"],
      ["Africa/Harare", "Africa/Zimbabwe/Harare"],
      ["Africa/Nairobi", "Africa/Kenya/Nairobi"],
    ],
  },
  {
    group: "Asia",
    zones: [
      ["Asia/Almaty", "Asia/Kazakhstan/Almaty"],
      ["Asia/Novosibirsk", "Asia/Russia/Novosibirsk"],
      ["Asia/Baghdad", "Asia/Iraq/Baghdad"],
      ["Asia/Baku", "Asia/Azerbaijan/Baku"],
      ["Asia/Tbilisi", "Asia/Georgia/Tbilisi"],
      ["Asia/Yerevan", "Asia/Armenia/Yerevan"],
      ["Asia/Bangkok", "Asia/Thailand/Bangkok"],
      ["Asia/Ho_Chi_Minh", "Asia/Vietnam/Ho Chi Minh"],
      ["Asia/Jakarta", "Asia/Indonesia/Jakarta"],
      ["Asia/Makassar", "Asia/Indonesia/Bali"],
      ["Asia/Colombo", "Asia/Sri Lanka/Colombo"],
      ["Asia/Dhaka", "Asia/Bangladesh/Dhaka"],
      ["Asia/Dubai", "Asia/UAE/Dubai"],
      ["Asia/Irkutsk", "Asia/Russia/Irkutsk"],
      ["Asia/Ulaanbaatar", "Asia/Mongolia/Ulaanbaatar"],
      ["Asia/Jerusalem", "Asia/Israel/Jerusalem"],
      ["Asia/Kabul", "Asia/Afghanistan/Kabul"],
      ["Asia/Kamchatka", "Asia/Russia/Kamchatka"],
      ["Asia/Karachi", "Asia/Pakistan/Karachi"],
      ["Asia/Tashkent", "Asia/Uzbekistan/Tashkent"],
      ["Asia/Kathmandu", "Asia/Nepal/Kathmandu"],
      ["Asia/Kolkata", "Asia/India/Kolkata"],
      ["Asia/Krasnoyarsk", "Asia/Russia/Krasnoyarsk"],
      ["Asia/Kuala_Lumpur", "Asia/Malaysia/Kuala Lumpur"],
      ["Asia/Singapore", "Asia/Singapore"],
      ["Asia/Kuwait", "Asia/Kuwait"],
      ["Asia/Riyadh", "Asia/Riyadh"],
      ["Asia/Magadan", "Asia/Russia/Magadan"],
      ["Asia/Yangon", "Asia/Myanmar/Yangon"],
      ["Asia/Seoul", "Asia/South Korea/Seoul"],
      ["Asia/Shanghai", "Asia/China/Shanghai"],
      ["Asia/Taipei", "Asia/Taiwan/Taipei"],
      ["Asia/Tehran", "Asia/Iran/Tehran"],
      ["Asia/Tokyo", "Asia/Japan/Tokyo"],
      ["Asia/Vladivostok", "Asia/Russia/Vladivostok"],
      ["Asia/Yakutsk", "Asia/Russia/Yakutsk"],
      ["Asia/Yekaterinburg", "Asia/Russia/Yekaterinburg"],
    ],
  },
  {
    group: "Atlantic",
    zones: [
      ["Atlantic/Azores", "Atlantic/Portugal/Azores"],
      ["Atlantic/Canary", "Atlantic/Spain/Canary Islands"],
      ["Atlantic/Cape_Verde", "Atlantic/Cape Verde"],
    ],
  },
  {
    group: "Australia",
    zones: [
      ["Australia/Adelaide", "Australia/Adelaide"],
      ["Australia/Brisbane", "Australia/Brisbane"],
      ["Australia/Darwin", "Australia/Darwin"],
      ["Australia/Hobart", "Australia/Hobart"],
      ["Australia/Perth", "Australia/Perth"],
      ["Australia/Sydney", "Australia/Sydney"],
      ["Australia/Melbourne", "Australia/Melbourne"],
    ],
  },
  { group: "UTC", zones: [["UTC", "UTC Time"]] },
  {
    group: "Europe",
    zones: [
      ["Europe/Amsterdam", "Europe/Netherlands/Amsterdam"],
      ["Europe/Berlin", "Europe/Germany/Berlin"],
      ["Europe/Zurich", "Europe/Switzerland/Bern"],
      ["Europe/Rome", "Europe/Italy/Rome"],
      ["Europe/Stockholm", "Europe/Sweden/Stockholm"],
      ["Europe/Vienna", "Europe/Austria/Vienna"],
      ["Europe/Athens", "Europe/Greece/Athens"],
      ["Europe/Belgrade", "Europe/Serbia/Belgrade"],
      ["Europe/Bratislava", "Europe/Slovakia/Bratislava"],
      ["Europe/Budapest", "Europe/Hungary/Budapest"],
      ["Europe/Ljubljana", "Europe/Slovenia/Ljubljana"],
      ["Europe/Prague", "Europe/Czech Republic/Prague"],
      ["Europe/Brussels", "Europe/Belgium/Brussels"],
      ["Europe/Copenhagen", "Europe/Denmark/Copenhagen"],
      ["Europe/Madrid", "Europe/Spain/Madrid"],
      ["Europe/Paris", "Europe/France/Paris"],
      ["Europe/Bucharest", "Europe/Romania/Bucharest"],
      ["Europe/Dublin", "Europe/Ireland/Dublin"],
      ["Europe/Helsinki", "Europe/Finland/Helsinki"],
      ["Europe/Kyiv", "Europe/Ukraine/Kyiv"],
      ["Europe/Riga", "Europe/Latvia/Riga"],
      ["Europe/Sofia", "Europe/Bulgaria/Sofia"],
      ["Europe/Tallinn", "Europe/Estonia/Tallinn"],
      ["Europe/Vilnius", "Europe/Lithuania/Vilnius"],
      ["Europe/Lisbon", "Europe/Portugal/Lisbon"],
      ["Europe/London", "Europe/United Kingdom/London"],
      ["Europe/Moscow", "Europe/Russia/Moscow"],
      ["Europe/Istanbul", "Europe/Turkey/Istanbul"],
      ["Europe/Minsk", "Europe/Belarus/Minsk"],
      ["Europe/Volgograd", "Europe/Russia/Volgograd"],
      ["Europe/Sarajevo", "Europe/Bosnia and Herzegovina/Sarajevo"],
      ["Europe/Skopje", "Europe/North Macedonia/Skopje"],
      ["Europe/Warsaw", "Europe/Poland/Warsaw"],
      ["Europe/Zagreb", "Europe/Croatia/Zagreb"],
    ],
  },
  {
    group: "Pacific",
    zones: [
      ["Pacific/Auckland", "Pacific/New Zealand/Auckland"],
      ["Pacific/Fiji", "Pacific/Fiji"],
      ["Pacific/Gambier", "Pacific/French Polynesia/Gambier"],
      ["Pacific/Guam", "Pacific/Guam"],
      ["Pacific/Port_Moresby", "Pacific/Papua New Guinea/Port Moresby"],
      ["Pacific/Honolulu", "Pacific/USA/Honolulu"],
      ["Pacific/Marquesas", "Pacific/French Polynesia/Marquesas"],
      ["Pacific/Midway", "Pacific/USA/Midway"],
      ["Pacific/Pago_Pago", "Pacific/American Samoa"],
    ],
  },
]

const BY_ID = {}
TIME_ZONE_GROUPS.forEach(({ zones }) =>
  zones.forEach(([id, label]) => {
    BY_ID[id] = label
  })
)

// Zones the browser reports that are not in the list above still have to render
// a sensible header, so fall back to the raw IANA name's last segment.
export const zoneHeading = (id) => {
  const label = BY_ID[id]
  if (!label) return String(id).split("/").pop().replace(/_/g, " ")
  if (!label.includes("/")) return label
  const parts = label.split("/")
  return `${parts.length > 2 ? parts[1] : parts[parts.length - 1]} Time`
}

export const detectZone = () => {
  try {
    return (
      Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Amsterdam"
    )
  } catch (e) {
    return "Europe/Amsterdam"
  }
}
